import { useImmer } from "use-immer";
import { useEffect, useRef, useState } from "react";
import { getRefundableItemsApi, partialRefundApi } from "../api";
import { errorMessage, successMessage } from "../../../utils";
import { useNavigate } from "react-router-dom";
import SimpleReactValidator from "simple-react-validator";
export const usePartialRefund = ({ orderId, state }) => {
  const [, forceUpdate] = useState();
  const validator = useRef(
    new SimpleReactValidator({
      autoForceUpdate: { forceUpdate: forceUpdate },
      validators: {
        customqty: {
          message:
            "Refund quantity must be between 0 and the product quantity.",
          rule: (val) => {
            const { refundQty, qty } = val;

            return refundQty >= 0 && refundQty <= qty;
          },
        },
        deduction: {
          message:
            "Deduction amount must be less than or equal to the total amount.",
          rule: (val) => {
            const { deduction_amount, total_amount } = val;
            return deduction_amount >= 0 && deduction_amount <= total_amount;
          },
        },
      },
    }),
  );
  const navigate = useNavigate();
  const [refundState, setRefundState] = useImmer({
    reason: "",
    deduct_fee: 0,
    deduction_amount: "",
    refund_items: [],
    isSubmitting: false,
    isSubmitOpen: false,
    refundableItems: [],
  });

  useEffect(() => {
    if (state.data.products.length > 0) {
      setRefundState((draft) => {
        draft.refund_items = state.data.products.map((item) => ({
          ...item,
          refundQty: 0,
        }));
      });
      getRefundableItems();
    }
  }, [state.data.products]);

  const getRefundableItems = async () => {
    try {
      const res = await getRefundableItemsApi(orderId);
      setRefundState((draft) => {
        draft.refundableItems = res.data;
      });
    } catch (error) {
      errorMessage(error.response?.data?.message || "Something went wrong");
    }
  };

  const onChangeRefundQty = (e, index) => {
    setRefundState((draft) => {
      draft.refund_items[index].refundQty = e.target.value;
    });
  };

  const inrementOrDecrementQty = (type, index) => {
    if (type === "increment") {
      setRefundState((draft) => {
        draft.refund_items[index].refundQty =
          draft.refund_items[index].refundQty + 1;
      });
    } else {
      setRefundState((draft) => {
        draft.refund_items[index].refundQty =
          draft.refund_items[index].refundQty - 1;
      });
    }
  };

  const checkIfRefundable = (itemId) => {
    const isRefundable = refundState.refundableItems.find(
      (refundItem) => refundItem.id === itemId,
    );
    if (isRefundable && isRefundable.is_it_refundable == 0) {
      return false;
    }
    return true;
  };

  const addAll = () => {
    setRefundState((draft) => {
      draft.refund_items = draft.refund_items.map((item) => ({
        ...item,
        refundQty: checkIfRefundable(item.id) ? item.quantity : 0,
      }));
    });
  };

  const onChange = (e) => {
    const { value, name } = e.target;
    setRefundState((draft) => {
      draft[name] = value;
    });
  };

  // onSubmit handler for partial refund
  const onSubmit = async () => {
    try {
      const payload = {
        reason: refundState.reason,
        deduct_fee: refundState.deduction_amount > 0 ? 1 : 0,
        deduction_amount: refundState.deduction_amount || 0,
        refund_items: refundState.refund_items
          .filter((item) => Number(item.refundQty) > 0)
          .map((item) => ({
            order_product_id: item.id,
            quantity: item.refundQty,
          })),
      };
      setRefundState((draft) => {
        draft.isSubmitting = true;
      });

      const res = await partialRefundApi(orderId, payload);
      successMessage(res.message || "Refund successful");
      navigate(`/orders/details/${orderId}`, { replace: true });
      setRefundState((draft) => {
        draft.isSubmitting = false;
      });
      openRefundModal();
      return res;
    } catch (error) {
      errorMessage(error.response?.data?.message || "Something went wrong");
      setRefundState((draft) => {
        draft.isSubmitting = false;
      });
    }
  };

  const openRefundModal = (type) => {
    if (type === "open") {
      if (validator.current.allValid()) {
        setRefundState((draft) => {
          draft.isSubmitOpen = !draft.isSubmitOpen;
        });
      } else {
        validator.current.showMessages();
        errorMessage("Please fill all the required fields correctly.");
        forceUpdate((prev) => !prev);
      }
    } else {
      setRefundState((draft) => {
        draft.isSubmitOpen = !draft.isSubmitOpen;
      });
    }
  };

  return {
    refundState,
    setRefundState,
    addAll,
    inrementOrDecrementQty,
    onSubmit,
    onChange,
    onChangeRefundQty,
    openRefundModal,
    validator,
    checkIfRefundable,
  };
};
